
import { experienceMapping } from '../mappings/ExperienceMapping';

export const applyExperienceFilter = (dbQuery: any, experienceType: string) => {
  const experienceKeywords = experienceMapping[experienceType as keyof typeof experienceMapping];
  
  if (!experienceKeywords || experienceKeywords.length === 0) {
    console.log('No keywords found for experience type:', experienceType);
    return dbQuery;
  }
  
  console.log('Applying experience filter for:', experienceType);
  console.log('Using keywords:', experienceKeywords);
  
  // Voor alle experience types: zoek alleen binnen de CONTENT van accommodaties
  // GEEN nieuwe locatie-filtering - de locatie is al hard gefilterd in een eerdere stap
  console.log('*** EXPERIENCE FILTER: Searching for experience terms WITHIN already filtered location ***');
  const orConditions = experienceKeywords.map(keyword => [
    `description.ilike.%${keyword}%`,
    `facilities.ilike.%${keyword}%`,
    `specialCategories.ilike.%${keyword}%`,
    `categoryPath.ilike.%${keyword}%`,
    `name.ilike.%${keyword}%`
  ]).flat();
  
  console.log('Generated OR conditions (within already filtered location):', orConditions);
  
  return dbQuery.or(orConditions.join(','));
};
